import { render, staticRenderFns } from "./ApexHeatMapConfirmations.vue?vue&type=template&id=6f1c9730&"
import script from "./ApexHeatMapConfirmations.vue?vue&type=script&lang=js&"
export * from "./ApexHeatMapConfirmations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports